import React from "react";
import ProductGrid from "./ProductGrid";
import remedyImage from "../assets/images/Report.png";
import styles from "../styles/ServiceSection.module.css";

const ReportServices = ({ variant = "cards" }) => {
  return (
    <section className={styles.serviceSection} id="report-section">
      <ProductGrid
        serviceId={1}
        title="Prasna Kundli"
        defaultPageSize={20}
        showPagination={true}
        defaultImage={remedyImage}
        useProductImages={true}  // Product's main image; default image if it has none
        variant={variant}
        viewAllLink={variant === "carousel" ? "/prashnakundali" : null}
      />
  
    </section>
  );
};

export default ReportServices;
